import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Modal from '@mui/material/Modal';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import useAxiosPrivate from "../../utils/hooks/useAxiosPrivate";

const modalPaperSx = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: { xs: 'min(calc(100% - 32px), 420px)', sm: 450 },
    maxWidth: '100%',
    maxHeight: 'calc(100vh - 48px)',
    overflow: 'auto',
    bgcolor: 'var(--primary-popup-background-color)',
    color: 'var(--primary-text-color)',
    border: '1px solid var(--primary-popup-stroke-color)',
    borderRadius: '5px',
    p: 3,
    outline: 'none',
};

export default function BasicModal(props) {
    const axios = useAxiosPrivate()
    const { setOpen, open, group, setAlert, loadDataGroupData, setDeleteTeam } = props
    const handleClose = () => setOpen(false);

    const DeleteTeam = async () => {
        try {
            await axios.delete(`/group/${group}`);
            loadDataGroupData()
            handleClose()
            setAlert({
                showAlert: true,
                severity: 'Success',
                message: 'Team deleted Successfully!',
            });
            setDeleteTeam(true)
            setTimeout(() => {
                setAlert({
                    showAlert: false,
                    severity: 'Success',
                    message: 'Team deleted Successfully!',
                });
            }, 5000);

        } catch (error) {
            setAlert({
                showAlert: true,
                severity: "error",
                message: "Something was wrong!",
            });
        }
    };

    return (
        <div>
            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="delete-team-modal-title"
                aria-describedby="delete-team-modal-description"
                BackdropProps={{
                    sx: {
                        backgroundColor: 'var(--primary-popup-overlay-bg)',
                        backdropFilter: 'var(--primary-popup-overlay-blur)',
                    },
                }}
            >
                <Box sx={modalPaperSx}>
                    <Stack
                        id="delete-team-modal-description"
                        spacing={2.5}
                        alignItems="stretch"
                    >
                        <Typography
                            id="delete-team-modal-title"
                            sx={{
                                textAlign: 'center',
                                fontFamily: '"Poppins", sans-serif',
                                fontWeight: 600,
                                fontSize: '1.125rem',
                                lineHeight: 1.45,
                                color: 'var(--primary-text-color)',
                                px: 0.5,
                            }}
                        >
                            Are you sure you want to delete this team?
                        </Typography>
                        <Stack
                            direction={{ xs: 'column', sm: 'row' }}
                            spacing={2}
                            justifyContent="center"
                            alignItems="stretch"
                            sx={{ pt: 0.5 }}
                        >
                            <Button
                                size="large"
                                variant="contained"
                                onClick={() => DeleteTeam()}
                                sx={{
                                    fontSize: '0.9rem',
                                    lineHeight: 1.25,
                                    fontFamily: '"Poppins", sans-serif',
                                    fontWeight: 500,
                                    minWidth: { sm: 150 },
                                    py: 1.25,
                                    textTransform: 'none',
                                    backgroundColor:
                                        'var(--primary-button-background-color)',
                                    color: 'var(--primary-button-text-color)',
                                    opacity: 0.9,
                                    '&:hover': {
                                        backgroundColor:
                                            'var(--primary-button-background-color)',
                                        opacity: 0.8,
                                    },
                                }}
                            >
                                Yes, delete it
                            </Button>
                            <Button
                                size="large"
                                variant="outlined"
                                onClick={() => handleClose()}
                                sx={{
                                    fontSize: '0.9rem',
                                    lineHeight: 1.25,
                                    fontFamily: '"Poppins", sans-serif',
                                    fontWeight: 500,
                                    minWidth: { sm: 150 },
                                    py: 1.25,
                                    textTransform: 'none',
                                    borderColor: 'var(--primary-popup-stroke-color)',
                                    color: 'var(--primary-text-color)',
                                    '&:hover': {
                                        borderColor:
                                            'var(--primary-popup-stroke-color)',
                                        backgroundColor:
                                            'rgba(255, 255, 255, 0.06)',
                                    },
                                }}
                            >
                                No, stay here
                            </Button>
                        </Stack>
                    </Stack>
                </Box>
            </Modal>
        </div>
    );
}